import { render, staticRenderFns } from "./PersonFormular.vue?vue&type=template&id=5176e234"
import script from "./PersonFormular.vue?vue&type=script&lang=js"
export * from "./PersonFormular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GlobalFormulareKontakt: require('/Users/stefan/Dropbox/Stefan/gitrepos/p1ng/gnoema/frontend/components/global/formulare/kontakt.vue').default})
